import { RouteObject } from "react-router";
import { Lazy } from "@shared/components/ui/lazy";

const Appointments = Lazy(() => import("@shared/features/medicalRecord/pages/PatientAppointments"), "PatientAppointments");
const Documents = Lazy(() => import("@shared/features/medicalRecord/pages/PatientDocuments"), "PatientDocuments");
const MedicalRecord = Lazy(() => import("@shared/features/medicalRecord/pages/MedicalRecord"), "MedicalRecord");
const PatientList = Lazy(() => import("@shared/features/patientList/pages/PatientList"), "PatientList");

export interface PatientManagementRoutesProps {
  useOrganization?: boolean;
}

export const getPatientManagementRoutes = (
  props: PatientManagementRoutesProps = {}
): RouteObject[] => {
  const { useOrganization } = props;
  const routes: RouteObject[] = [];

  if (!useOrganization) {
    routes.push({ path: "medical-record", element: <MedicalRecord /> });
  }

  routes.push({
    path: "patients",
    children: [
      {
        index: true,
        element: <PatientList useOrganization={useOrganization} />,
      },
      {
        path: ":patientId",
        children: [
          { index: true, element: <MedicalRecord /> },
          { path: "appointments", element: <Appointments /> },
          { path: "documents", element: <Documents /> },
        ],
      },
    ],
  });

  return routes;
};
